import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubjectMobile } from "../../../Pages/SubjectMobile/ISubjectMobile";

export const ListSubjectMobileSlice = createSlice({
  name: "ListSubjectMobileSlice",
  initialState: {} as IReduxState<ISubjectMobile[]>,
  reducers: {
    listSubjectMobile: (state) => {
      state.isLoading = true;
    },
    successlistSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSubjectMobile: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistSubjectMobile,
  listSubjectMobile,
  successlistSubjectMobile,
} = ListSubjectMobileSlice.actions;

export default ListSubjectMobileSlice.reducer;
